export default {
  name: 'Last-Name',
  inject: {
    $validator: '$validator'
  },
  props: {
    placeholder: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      lastNameValue: this.value
    }
  },
  watch: {
    value (val) {
      this.lastNameValue = val
    }
  },
  methods: {
    updateLastNameData (event) {
      this.lastNameValue = event.target.value
      this.$emit('input', this.lastNameValue)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/component/inputs/lastName/lastName.js